export const buildAcademyExamCriteria = ({
  companyPrimaryId,
  userPrimaryId,
  examPrimaryId,
  scheduledProductId,
  productPrimaryId
}) => {
  // User_Exam stores a scheduled-product reference in two valid shapes:
  // scheduled enrollments use scheduledProduct.primaryId, while a product-only
  // enrollment can only be queried through scheduledProduct.product.primaryId.
  // Prefer the scheduled-product ID whenever it is available. Delivery type is
  // not reliable enough to infer the persisted reference (especially for
  // partner enrollments).
  const scheduledProduct = scheduledProductId !== undefined && scheduledProductId !== null && scheduledProductId !== ""
    ? { primaryId: scheduledProductId }
    : productPrimaryId !== undefined && productPrimaryId !== null && productPrimaryId !== ""
      ? { product: { primaryId: productPrimaryId } }
      : undefined;

  return {
    company: { primaryId: companyPrimaryId },
    user: { primaryId: userPrimaryId },
    exam: { primaryId: examPrimaryId },
    ...(scheduledProduct ? { scheduledProduct } : {})
  };
};

export const buildPrimaryIdCriteria = (primaryId) => ({
  primaryId
});

export const buildAcademyExamByStoredUserCriteria = ({
  companyPrimaryId,
  userPrimaryId
}) => ({
  company: {
    primaryId: companyPrimaryId
  },
  user: {
    primaryId: userPrimaryId
  }
});
